import React, {PureComponent} from 'react';
import {Spin} from 'antd';
import {withTranslation, WithTranslation} from 'react-i18next'
import {Bar, defaults, Line} from "react-chartjs-2";
import {EmployeesReport} from '../stores/employee-report-store';

export const colors:string[] = [
    "#800000 ",
    "#8B0000 ",
    "#A52A2A ",
    "#B22222 ",
    "#DC143C ",
    "#FF6347 ",
    "#FF7F50 ",
    "#CD5C5C ",
    "#F08080 ",
    "#E9967A ",
    "#FA8072 ",
    "#B8860B ",
    "#DAA520 ",
    "#BDB76B ",
    "#F0E68C ",
    "#808000 ",
    "#FFFF00 ",
    "#9ACD32 ",
    "#556B2F ",
    "#6B8E23 ",
    "#7CFC00 ",
    "#7FFF00 ",
    "#ADFF2F ",
    "#006400 ",
    "#008000 ",
    "#228B22 ",
    "#32CD32 ",
    "#90EE90 ",
    "#98FB98 ",
    "#8FBC8F ",
    "#00FA9A ",
    "#00FF7F ",
    "#2E8B57 ",
    "#66CDAA ",
    "#3CB371 ",
    "#20B2AA ",
    "#2F4F4F ",
    "#008080 ",
    "#008B8B ",
    "#00FFFF ",
    "#00FFFF ",
    "#E0FFFF ",
    "#00CED1 ",
    "#40E0D0 ",
    "#48D1CC ",
    "#AFEEEE ",
    "#7FFFD4 ",
    "#B0E0E6 ",
    "#5F9EA0 ",
    "#4682B4 ",
    "#6495ED ",
    "#00BFFF ",
    "#1E90FF ",
    "#ADD8E6 ",
    "#87CEEB ",
    "#87CEFA ",
    "#191970 ",
    "#000080 ",
    "#00008B ",
    "#0000CD ",
    "#0000FF ",
    "#4169E1 ",
    "#8A2BE2 ",
    "#4B0082 ",
    "#483D8B ",
    "#6A5ACD ",
    "#7B68EE ",
    "#9370DB ",
    "#8B008B ",
    "#9400D3 ",
    "#9932CC ",
    "#BA55D3 ",
    "#800080 ",
    "#D8BFD8 ",
    "#DDA0DD ",
    "#EE82EE ",
    "#FF00FF ",
    "#DA70D6 ",
    "#C71585 ",
    "#DB7093 ",
    "#FF1493 ",
    "#FF69B4 ",
    "#FFB6C1 ",
    "#FFC0CB ",
    "#A0522D ",
    "#D2691E ",
    "#CD853F ",
    "#F4A460 ",
    "#DEB887 ",
    "#D2B48C ",
    "#BC8F8F ",
    "#FFE4B5 ",
    "#FFDEAD ",
    "#FFDAB9 ",
    "#FFE4E1 ",
    "#708090 ",
    "#778899 ",
    "#B0C4DE ",
    "#E6E6FA ",
    "#696969 ",
    "#808080 ",
    "#A9A9A9 ",
    "#C0C0C0 ",
    "#D3D3D3 "]

defaults.global.defaultFontFamily = "'Avenir','Helvetica Neue','Arial','Helvetica',sans-serif"
defaults.global.defaultFontSize = 14

interface EmployeesReportChartProps extends WithTranslation {
    renderToggle: boolean,
    data: EmployeesReport,
    colors: string[],
    colorsForPojects: string[],
    showBar?: boolean,
    showPie?: boolean
}

interface EmployeesReportChartState {
    renderToggle: boolean,
    isBusy: boolean,
}

export function GetColors(amount: number): string[]{
    var availableColors = [...colors]
    var remain = amount
    var result:string [] = []
    while (remain > 0) {
        if (availableColors.length == 0) {
            availableColors = [...colors]
        }
        let index = Math.floor(Math.random() * availableColors.length)
        result.push(availableColors[index])
        availableColors.splice(index, 1)
        result.push()
        remain--
    }
    return result
}

class EmployeesReportChart extends PureComponent<EmployeesReportChartProps, EmployeesReportChartState> {

    constructor(props: EmployeesReportChartProps) {
        super(props);

        this.state = {
            renderToggle: this.props.renderToggle,
            isBusy: false,

        }
    }
    private parseTime(h: any, format?: any) {
        if (format == null) {
            var hours = parseFloat(h).toFixed(2)
            return hours
        }
    }

    render() {
        const { t } = this.props;
        const showBar = this.props.showBar;
        const showPie = this.props.showPie;
        const colors = this.props.colors;
        const colorsForPojects = this.props.colorsForPojects;

        //build labels legend
        var projectIds: string[] = []
        var projectNames: string[] = []
        Array.from(this.props.data.projectIdToName).forEach((item) => {
            projectIds.push(item[0])
            projectNames.push(item[1])
        })

        let data = {
            labels: projectNames,
            datasets: this.props.data.reports.map((report, index) => {
                return {
                    label: report.employeeName,
                    data: projectIds.map(id => (this.parseTime(report.workedHoursPerProject.get(id))) ?? 0),
                    fill: true,
                    backgroundColor: colors[index],
                    hoverBackgroundColor: colors[index],
                    borderColor: 'rgba(200, 200, 200, 0.75)',
                    hoverBorderColor: 'rgba(200, 200, 200, 1)'
                }
            })
        }

        const monthNames = [t("January"), t("February"), t("March"), t("April"), t("May"), t("June"),
        t("July"), t("August"), t("September"), t("October"), t("November"), t("December")];

        let lineData = {
            datasets: projectIds.map((p, index) => ({
                data: this.props.data.reports.reduce((ac, r) => {
                    const workedHoursPerProjectByMonth = r.workedHoursPerProjectByMonth.get(p);
                    if (workedHoursPerProjectByMonth) 
                        for (var i = 0; i < 12; i++) ac[i] += workedHoursPerProjectByMonth[i];
                    return ac;
                }, new Array<number>(12).fill(0)),
                borderColor: colorsForPojects[index],
                label: this.props.data.projectIdToName.get(p),
                fill: false,
                tension: 0
            })),
            labels: monthNames
        }

        let options = {
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    }
                }],
                xAxes: [{
                    barPercentage: 0.4
                }]
            },
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: t("Worked hours per project")
            }
        }

        const lineOptionsTime = {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: t("Total worked hours by month")
            }
        };

        return <Spin size='large' spinning={this.state.isBusy} style={{ width: "100%"}}>
            <div className="flex-container" style={{ padding: 10, width: "100%", height: "60vh" }}>
                {showBar &&
                    < div className="flex" style={{ width:"50%" }}>
                        <Bar
                        data={data}
                        options={options}
                        redraw={true}
                        />
                    </div>}
                {showPie &&
                    < div className="flex" style={{ width: "50%" }}>
                        <Line data={lineData} options={lineOptionsTime} />
                    </div>}
            </div>
        </Spin>
    }
}
export default withTranslation()(EmployeesReportChart);
